
if (document.querySelector('[data-verify-btn]')) {
    localStorage.removeItem('verify_checkout');
    document.querySelector('[data-verify-btn]').addEventListener('click', (event) => {
        event.preventDefault();
        var totalQues = document.querySelectorAll('[data-single-que-ans]').length;
        var randomCount = Math.floor(Math.random() * (totalQues)) + 1;
        _enableQuestions(randomCount);
      if (document.querySelector('#dynamic-checkout-cart') != null) {
        let findShopPayBtn = setInterval((event) => {
          let shopPayButton = document.querySelector('ul li [data-testid="ShopifyPay-button"]');
          if (shopPayButton != null) {
              shopPayButton.closest('li').setAttribute('id', 'shoppay-button');
              clearInterval(findShopPayBtn);
          }
        }, 100);
        let findAmazonPayBtn = setInterval((event) => {
          let amazonPayButton = document.querySelector('ul li.XLcXEW3RnM9fyU7k7fvC form');
          if (amazonPayButton != null) {
            amazonPayButton.closest('li').setAttribute('id', 'amazonpay-button');
            clearInterval(findAmazonPayBtn);
          }
        }, 100);
        let findGooglePayBtn = setInterval((event) => {
          let googlePayButton = document.querySelector('ul li [data-testid="GooglePay-button"]');
          if (googlePayButton != null) {
            googlePayButton.closest('li').setAttribute('id', 'googlepay-button');
            clearInterval(findGooglePayBtn);
          }
        }, 100);
      }
    })
}
document.querySelectorAll('[data-button_next]').forEach((ele) => {
    ele.addEventListener('click',(event) =>{
		var checkedAns = event.target.closest('[data-single-que-ans]').querySelector('[data-single-ans] input:checked');
		var quesOfCheckedAns = event.target.closest('[data-single-que-ans]').querySelector('[data-single-que] h4').textContent;
        if(checkedAns != null){
            if (checkedAns) {
                if (event.target.closest('[data-single-que-ans]').querySelector('[data-single-ans]').getAttribute('data-single-ans') == checkedAns.closest('[data-single-ans]').getAttribute('data-single-ans')) {
                    if (document.querySelector('#ModalClose-question-modal') != null) {
                        document.querySelector('#ModalClose-question-modal').click();
                    }
                    document.querySelector('[data-modal-opener="question-modal"]').classList.add('d-none');
					document.querySelector('[data-verify_checkout]').classList.remove('d-none');
                    localStorage.setItem('verify_checkout','true');
                } else {
                    localStorage.setItem('verify_checkout','false');
                    alert('You answered incorrectly. Please try again.')
                    window.location.href="/cart"
				}

				var checkedQuesAns = `${quesOfCheckedAns} : ${checkedAns.value}`;
				let dataForm = JSON.stringify({ attributes: { 'SecurityQueAns': checkedQuesAns } });
				fetch("/cart/update", {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					"Accept": "application/json"
				},
				body: dataForm,
				}).then(function (data) {
				});
            }
        }
    })
})

document.querySelectorAll('[data-single-ans] input').forEach(ele => {
    ele.addEventListener('click',(event)=>{
        if(ele.checked){
            ele.closest('[data-single-que-ans]').querySelector('[data-button_next]').classList.remove('disable')
        }
    })
});

function _enableQuestions(random) {
    console.log(random,'random');
    document.querySelectorAll('[data-single-que-ans]').forEach(ele => {
        if (parseInt(ele.getAttribute('data-single-que-ans')) != parseInt(random)) {
            ele.classList.add('d-none')
        }else{
            ele.classList.remove('d-none')
        }
    });
}

if (localStorage.getItem('verify_checkout') == 'true') {
	if (document.querySelector('#security').getAttribute('data-security') == 'true') {
        document.querySelector('[data-modal-opener="question-modal"]').classList.add('d-none');
        document.querySelector('[data-verify_checkout]').classList.remove('d-none');
	} else {
		localStorage.removeItem('verify_checkout');
    }
}

if (document.querySelector('.cart-page')) {
    if (window.globalVariables.cart.attributes.count != '' || window.globalVariables.cart.attributes.count != undefined) {
        let dataForm = JSON.stringify({attributes: { 'count': '' } });
        fetch("/cart/update", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            body: dataForm,
            }).then(function (data) {
        });
    }
}